import { render, staticRenderFns } from "./Cerrahi.vue?vue&type=template&id=2fceca42&scoped=true&"
import script from "./Cerrahi.vue?vue&type=script&lang=js&"
export * from "./Cerrahi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fceca42",
  null
  
)

export default component.exports